module.exports = __webpack_public_path__ + "static/img/shanghai.892dc12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shanghai.jpg
// module id = bg+F
// module chunks = 1